module.exports = __webpack_public_path__ + "static/gallery-7@2x-a4e7b959fea1ef40055e21deb228c3e1.jpg";